<template lang="pug">
button.btn.btn-default(
  type="button"
  :disabled="disabled"
  @click.prevent="cloneStory"
  @mousedown="hideTooltip"
  ref="duplicateButton"
  data-toggle="tooltip"
  data-container="body"
  title="Duplicate"
)
  i.fa.fa-clone
  span.duplicate-label(v-if="!hideLabel")
    |
    | Dupe
</template>

<script>
import { storyRoute } from '@/utils/route_helpers.js'

export default {
  props: {
    storyId: {
      type: Number,
      required: true
    },

    storyName: {
      type: String,
      required: false
    },

    hideLabel: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    name() {
      return this.storyName || 'this story';
    }
  },

  methods: {
    hideTooltip() {
      if (this.$refs.duplicateButton) {
        jQuery(this.$refs.duplicateButton).tooltip('hide')
      }
    },

    cloneStory() {
      this.$store.dispatch('stories/clone', { id: this.storyId }).then(({ story }) => {
        this.$router.push(storyRoute({
          storyId: story.id,
          storyRoute: 'editStory',
          issueRoute: 'editIssueStory',
          pageRoute: 'editPageStory',
          router: this.$router
        }))

        this.$store.dispatch('messages/addNotice', 'Story cloned')
        this.$emit('cloned', story)
      }).catch((error) => {
        console.error('Error cloning story:', error)
        this.$store.dispatch('messages/addError', 'Failed to clone story: ' + (error.response?.data?.message || error.message))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .duplicate-label {
    margin-left: 5px;
  }
</style>